(function () {
  var STORAGE_KEY = 'configuratorDemoTourHidden';

  function init() {
    var btn = document.getElementById('demo-tour-toggle-btn');
    if (!btn) return;

    function getTour() {
      return document.querySelector('[id$="__demo_tour"]');
    }

    function applyState(hidden) {
      var tour = getTour();
      if (tour) tour.style.display = hidden ? 'none' : '';
      btn.textContent = hidden ? '▼ Show demo tour' : '▲ Hide demo tour';
    }

    var hidden = false;
    try { hidden = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
    applyState(hidden);

    btn.addEventListener('click', function () {
      var tour = getTour();
      if (!tour) return;
      var nowHidden = tour.style.display !== 'none';
      try { localStorage.setItem(STORAGE_KEY, nowHidden ? '1' : '0'); } catch (e) {}
      applyState(nowHidden);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
